// ----------------------------------------------------------------------
// <copyright file="Izenda.ValidateRoleAssociation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ValidateRoleAssociation component
 */
!(function() {


  var React = require('react');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.UserAccountConstants');

  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var Input = require('share/components/controls/Izenda.Input');
  var Button = require('share/components/controls/Izenda.Button');
  var EventsUtils = require('EventUtils');
  const { forEach, isEmpty } = require('lodash/fp');

  var ValidateRoleAssociation = connect()(function(props) {
    var store = props.store;
    var configUserCloned = store.configUserCloned;
    var validations = configUserCloned.sendEmail ? constants.USER_SETUP_CONSTRAINTS.RECIPIENTS : null;
    var localization = props.localization;
    var renderCategories = function() {
      var listCategories = [];
      forEach(function(category) {
        listCategories.push(
          <GridLayout.Row key={category.id}>
            <GridLayout.Col cols="12">
              {category.name}
              {!isEmpty(category.subCategories) && renderSubCategories(category.subCategories)}
            </GridLayout.Col>
          </GridLayout.Row>
        );
      }, props.data);

      return listCategories;
    };

    var renderSubCategories = function(subCategories) {
      var listSubcategory = [];
      forEach(function(subCate) {
        listSubcategory.push(
          <GridLayout.Row key={subCate.id}>
            <GridLayout.Col cols="1" />
            <GridLayout.Col cols="11">{subCate.name}</GridLayout.Col>
          </GridLayout.Row>
        );
      }, subCategories);

      return listSubcategory;
    };

    return (
      <Popup visible type="error" onClosing={props.onReject} autoClose={false}>
        <Popup.Header title={localization.getText('COMMON_MESSAGES_ERROR')} className="u_floatLeft" />
        <Popup.Body>
          <GridLayout className="izenda-PasswordOptions">
            <GridLayout.Row>{constants.VALIDATE_RESULT_ROLE_ASSOCIATION_KEYS[props.messageKey]}</GridLayout.Row>

            {renderCategories()}

            <GridLayout.Row>{localization.getText('USER_SETUP_ERROR_ROLE_ASSOCIATION_MESSAGE')}</GridLayout.Row>
          </GridLayout>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type="cancel">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  });

  module.exports = ValidateRoleAssociation;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/UserSetupDetail/Izenda.ValidateRoleAssociation.jsx